import { Hero } from "../components/Hero";
import { ServicesOverview } from "../components/ServicesOverview";
import { HowItWorks } from "../components/HowItWorks";
import { WhyChooseUs } from "../components/WhyChooseUs";
import { CitiesGrid } from "../components/CitiesGrid";
import { Testimonials } from "../components/Testimonials";
import { CTABanner } from "../components/CTABanner";

export default function HomePage() {
  return (
    <>
      <Hero />
      <ServicesOverview />
      <HowItWorks />
      <WhyChooseUs />
      <CitiesGrid />
      <Testimonials />
      <CTABanner />
    </>
  );
}
